class StickyHeader {
    constructor() {
        this.$elm = $('.header');
        this.$html = $('html');
        this.setEventListeners();

        this.stickyPoint = 0;
        this.lastScrollTop = 0;

    }

    setEventListeners() {
        $(window).on('scroll', this.onScroll.bind(this)).trigger('scroll');
    }

    onScroll(event) {
        var scrollTop = $.scrollY();
        var scrollDirectionIsDown = (scrollTop > this.lastScrollTop);

        if (scrollTop > this.stickyPoint) {
            this.$elm.addClass('header--isSticky');
            this.$html.addClass('is-scrolled');
        } else {
            this.$elm.removeClass('header--isSticky');
            this.$html.removeClass('is-scrolled');
        }

        //console.log(scrollTop, scrollDirectionIsDown);

        this.lastScrollTop = scrollTop;
    }
}

export default StickyHeader;